import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {EmailTemplateService} from '../../../services';

@Component({
  selector: 'app-emailtemplate-view-modal',
  templateUrl: './emailtemplate-view-modal.component.html',
  styleUrls: ['./emailtemplate-view-modal.component.css']
})
export class EmailtemplateViewModalComponent {

  emailTemplateDetail: any;
  idFromParent: number;

  constructor(
    private spinner: NgxSpinnerService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig,
    private emailTemplateService:EmailTemplateService,
  ) 
  { 
    this.idFromParent = config.data.id;
  }

  ngOnInit(): void {
    this.getEmailTemplateDetails();
  }

  getEmailTemplateDetails()
  {
    this.emailTemplateService.getEmailTemplateById(this.idFromParent).subscribe((data: any) => {
      this.emailTemplateDetail = data;
      console.log('this.emailTemplateDetail');
      console.log(this.emailTemplateDetail);
     });
  }

}
